export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-0 rounded-2xl overflow-hidden bg-background-50 border border-background-200">
          <div className="lg:w-1/2 relative min-h-[320px] md:min-h-[420px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Lifestyle%20product%20collection%20display%20with%20sneakers%20hoodies%20and%20streetwear%20items%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20photography%2C%20elegant%20composition%2C%20clean%20brand%20aesthetic%20with%20warm%20neutral%20palette&width=1000&height=800&seq=usfans-cta-product-u16&orientation=landscape"
              alt="USFans Spreadsheet"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute top-6 left-6">
              <span className="text-xs font-medium text-background-50 bg-foreground-900/60 px-3 py-1.5 rounded-full whitespace-nowrap">
                USFans Spreadsheet 2026
              </span>
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col items-center justify-center px-8 md:px-14 py-14 md:py-20 text-center">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
              Gotowy, aby odkryć USFans Spreadsheet?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-md mb-8">
              Dołącz do tysięcy zadowolonych użytkowników. Sprawdź najnowsze rankingi i arkusze już dziś.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-8 py-4 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap shadow-lg"
            >
              Przejdź do USFans Spreadsheet
              <span className="w-5 h-5 flex items-center justify-center ml-2">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}